module.exports = __webpack_public_path__ + "img/smart-city.16acaec7.jpg";